<template>
  <div class="policy-renewal">
    <div class="coverage">
      <div @click="goBack" class="backDiv" style="margin-left: 5px; margin-right: auto;">
        <i class="pi pi-arrow-left"></i>
        <span> Coverage</span>
      </div>

      <!-- Loop through coverage items -->
      <div class="coverage-item" v-for="coverage in linesOfCoverage" :key="coverage.coverageType">
        <div class="coverage-details">
          <h3>{{ coverage.line_of_coverage }}</h3>
          <div class="text-group">
            <p v-if="coverage.line_of_coverage !== 'Physical Damage'">Limit: ${{ coverage.limit_amount }}</p>
            <p>Deductible: {{ coverage.deductible }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="actions">
      <div class="change-text">
        <p class="change-request">Request Changes:</p>
        <p class="note">
          Please note that this does not initiate any changes to your current active policy.
        </p>
      </div>
      <textarea v-model="coverageChanges" type="text" placeholder="Please let the changes you wish to make to your current coverage information" class="changes-input"/>
      <button @click="goToDriverReview" class="btn btn-confirm done-button" :disabled="isButtonDisabled">Done! Go to Driver Review<i class="pi pi-arrow-right"></i></button>
    </div>
  </div>
</template>

  <script>
   export default {
  name: 'CoverageChanges',
  data() {
    return {
      linesOfCoverage: [],
      coverageChanges: ''
    };
  },
  computed: {
    isButtonDisabled() {
      return !this.coverageChanges || this.coverageChanges.trim().length === 0;
    }
  },
  mounted() {
    // Retrieve data from localStorage
    const storedData = localStorage.getItem('deruloData');
    if (storedData) {
      const data = JSON.parse(storedData);
     
      this.linesOfCoverage = data.lines_of_coverage || [];
    } else {
      console.error('No data found in localStorage');
    }

    const coverageChangesCheck = localStorage.getItem('coverage_changes');
    if (coverageChangesCheck){
      console.log("coverage changes exist in local");
      this.coverageChanges = coverageChangesCheck;
    } else {
      console.log("nothing exists");
    }
  },
  methods: {
    goToDriverReview() {
      if (this.coverageChanges.trim()) {
        localStorage.setItem('coverage_changes', this.coverageChanges);
        this.$router.push({
        path: '/driversinfo'
       });
      } else {
        this.showError = true;
      }
    },
    goBack() {
      // Store the current scroll position
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

      // Set a flag in sessionStorage before navigation
      sessionStorage.setItem('scrollToTop', 'true');
      sessionStorage.setItem('previousScrollPosition', scrollPosition);

      // Navigate back
      this.$router.go(-1);
    }
  }
};
  </script>
  
  
<style scoped>
i {
  margin-left: 10px;
}

.policy-renewal {
  text-align: center;
  padding: 10px;
}

header {
  margin-bottom: 20px;
}

.logo {
  max-width: 150px;
}

.steps {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.step {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 5px;
}

.step.completed {
  background-color: green;
}

.step.active {
  background-color: #4CAF50;
}

.coverage {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.coverage-item {
  background-color: #f9f9f9;
  border: 2px solid #ddd;
  border-radius: 7px;
  padding: 20px;
  width: 95%;
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
}

.coverage-details {
  flex-grow: 1;
  padding-right: 20px; /* Add some space between text and button */
}

.coverage-details h3 {
  margin: 0 0 10px 0; /* Ensure proper spacing between coverage type and limit/deductible */
}


.text-group p {
  margin: 0; /* Remove extra spacing */
}

.changes-input {
  width: 100%;
  padding: 10px;
  border: 2px solid #ddd;
  border-radius: 5px;
  margin-bottom: 20px;
  box-sizing: border-box;
  height: 6em; /* Default height for larger screens */
}

@media (max-width: 768px) {
  .changes-input {
    height: 70px; /* Adjust this value for mobile screens */
  }
}

@media (max-width: 480px) {
  .changes-input {
    height: 150px; /* Adjust this value for smaller mobile screens */
  }
}

@media (max-width: 600px) {
  .change-request-input {
    width: 95%;
  }
}

@media (min-width: 601px) and (max-width: 1200px) {
  .change-request-input {
    width: 80%;
  }
}

@media (min-width: 1201px) {
  .change-request-input {
    width: 60%;
  }
}

.change-request {
  font-weight: bold;
}

.change-text {
  width: 94%;
}

.actions {
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.copy-button {
  background-color: #4caf50;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: auto; /* Align the button to the bottom */
}

.copy-button:hover {
  background-color: #45a049;
}


.note {
  color: #888;
  margin-bottom: 10px;
}

@media (min-width: 1000px) {
  .policy-renewal {
    width: 550px !important;
  }
}
</style>